import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StopFilled } from "@ant-design/icons";
import { Button, Collapse, Result } from "antd";
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "../../others/i18n.js";
import { spacing } from "../../styles/spacing.js";
import { centered } from "../../styles/template.js";
function ForbiddenPage() {
    // Get params to retrieve reason
    const [search] = useSearchParams();
    const { t } = useTranslation();
    const message = search.get("message");
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: t("Forbidden")
                })
            }),
            /*#__PURE__*/ _jsx(ForbiddenInfo, {
                message: message
            })
        ]
    });
}
function ForbiddenInfo(props) {
    const { message, backUrl } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const handleGoBack = ()=>{
        // Navigate back to the previous page or default
        navigate(backUrl || "/rcb/service");
    };
    return /*#__PURE__*/ _jsxs("div", {
        style: centered,
        children: [
            /*#__PURE__*/ _jsx(Result, {
                status: "warning",
                icon: /*#__PURE__*/ _jsx(StopFilled, {}),
                title: t("Forbidden"),
                subTitle: t("You are not allowed to perform this action."),
                style: {
                    padding: 0
                }
            }),
            /*#__PURE__*/ _jsx(Collapse, {
                style: {
                    width: "50vh"
                },
                ghost: true,
                children: /*#__PURE__*/ _jsx(Collapse.Panel, {
                    header: t("... more"),
                    children: /*#__PURE__*/ _jsx("p", {
                        children: message || t("Access to this page is restricted. If you believe you should have access, please contact the administrator for assistance.")
                    })
                }, "1")
            }),
            /*#__PURE__*/ _jsx(Button, {
                type: "primary",
                onClick: ()=>handleGoBack(),
                style: {
                    margin: spacing.layout.content.margin
                },
                children: t("Back Home")
            }, "console")
        ]
    });
}
export { ForbiddenInfo, ForbiddenPage };
